import React from "react";
import { useSelector } from "react-redux";
import { openInNewTab } from "../../../utils/utils";
import ScrollShadow from "../../ui/scrollLTR/ScrollShadow/ScrollShadow";
import ToolsListItem from "./toolsListItem/ToolsListItem";
import classes from "./ToolsList.module.css";

const ToolsList = ({ text, tools, height, className, textLink, link, onEdit, onDelete, actionsType, leadingItem }) => {

    const { texts, lang } = useSelector(state => state.translate);

    return (
        <div className={`${classes.MyToolsListWrapper} ${className ?? ""}`} style={{ height: height }} >
            <div className={classes.Header}>
                {text && <p className={classes.Title}>{text}</p>}
                {link && <p className={classes.Link} onClick={() => { openInNewTab(link) }}>{textLink}</p>}
            </div>
            <ScrollShadow className={classes.ToolsScroll} showDots={true}>
                <div className={classes.MyToolsList}>
                    {leadingItem}
                    {tools?.length > 0 ?
                        tools?.map((tool, index) =>
                            <ToolsListItem
                                key={tool.toolId || tool.externalId || tool.id || index}
                                tool={tool}
                                lang={lang}
                                onEdit={onEdit}
                                onDelete={onDelete}
                                actionsType={actionsType}
                            />
                        )
                        :
                        <div className={classes.NoTools}>
                            {texts.noUsefulTools}
                        </div>
                    }
                </div>
            </ScrollShadow>
        </div>
    );
};

export default ToolsList;
